// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","526":"pages-DebugPage","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"27fed49b3a11c35ea06e","526":"9935f1bd814f9f3e96db","777":"a5046dc7a0966c7bb140","983":"9e94e13e074fd9caee1d"}[chunkId] + ".js";
};